export default __webpack_public_path__ + "static/media/corporate_admin_dashboard.29c89275.svg";